import {Image, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Text} = Typography;
const Content = Layout;

const IBS = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Content style={{background: 'inherit'}}>
          <Text className='BaseText6'>Interaction between aptamer modified with biotin and streptavidin: In order to see if the aptamer with biotin modification on its 5’ end binds correctly to streptavidin, we proposed a binding assay with alginate pearls. The alginate pearls will encapsulate the streptavidin and when the aptamers are added, these will bind to the streptavidin. The interaction will be visualized by adding an intercalating agent that should bind to the aptamer and generate fluorescence inside the pearls when it is seen with UV light.</Text>
          <Layout style={{background: 'transparent'}}>
            <Content style={{marginLeft: '50%', transform: 'translateX(-50%)', marginTop: '2vh', width: '60vh', background: 'transparent'}}>
              <Image src='https://static.igem.wiki/teams/4464/wiki/wet-lab/11.png' preview={false}/>
              <p style={{textAlign: 'center'}}>Fig 10. Diagram of interaction between aptamers with biotin and the<br/>streptavidin. Created with BioRender.com</p>
            </Content>
          </Layout>
        </Content>
      </Layout>
    </Layout>
  );
};

export default IBS;
